import { Divider, Modal } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import './modal.scss';

export interface ModalProps {
    title: string;
    isVisible: boolean;
    onClose: (value: boolean) => void;
    container?: string;
    footer: ReactNode | null;
    content?: ReactNode;
    closable?: boolean;
    maskClosable?: boolean;
    keyboard?: boolean;
    destroyOnClose?: boolean;
    className?: string;
    isInfoModal?: boolean;
    width?: number;
}

export const ConfigurableModal = (props: ModalProps): JSX.Element => {
    const { t } = useTranslation();

    const handleCancel = () => {
        props.onClose(false);
    };

    return (
        <Modal
            className={props.className ? props.className : 'custom-modal'}
            title={!props.isInfoModal ? t(props.title) : null}
            getContainer={props.container}
            open={props.isVisible}
            onCancel={handleCancel}
            width={props.width ?? 'auto'}
            centered
            closable={props.closable}
            keyboard={props.keyboard}
            destroyOnClose={props.destroyOnClose}
            maskClosable={props.maskClosable}
            footer={props.footer}
        >
            {props.isInfoModal && <div className="modal-title">{t(`${props.title}`)}</div>}
            <div className="modal-content">{props.content}</div>
        </Modal>
    );
};

export default ConfigurableModal;

export interface ConfirmationModalFooterProps {
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmationModalFooter = (props: ConfirmationModalFooterProps): JSX.Element => {
    const { t } = useTranslation();

    const { onConfirm, onCancel } = props;
    return (
        <>
            <div className="modal-button" onClick={onCancel}>
                <div className="modal-btn-text"> {t('COMMON.NO')}</div>
            </div>
            <Divider type="vertical" className="divider" />
            <div className="modal-button" onClick={onConfirm}>
                <div className="modal-btn-text"> {t('COMMON.YES')}</div>
            </div>
        </>
    );
};
